import useSbCategories, {
  UseSbCategoriesProps,
  UseSbCategoriesReturnProps,
} from './useSbCategories';

export default useSbCategories;
export type { UseSbCategoriesProps, UseSbCategoriesReturnProps };
